export default __webpack_public_path__ + "static/media/LT.496c6636.svg";